import { convertFileToBase64 } from 'app/utils';
import axios from 'axios';

export type GetOwnerEmployersArgs = {
  ownerId: string;
  page?: number;
  itemsPerPage?: number;
  searchQuery?: string;
};

export type GetDeletedConnectionsArgs = {
  employerId: string;
  page?: number;
  itemsPerPage?: number;
};

export type RestoreConnectionArgs = {
  connectionId: string;
};

export type GetConnectionByIdArgs = {
  connectionId: string;
};

export const adminServices = {
  async getOwnerEmployers({ ownerId, page = 1, itemsPerPage = 30, searchQuery }: GetOwnerEmployersArgs) {
    return axios.get(`/admin/owners/${ownerId}/employers`, {
      params: { page, itemsPerPage, searchQuery },
    });
  },

  async getDeletedConnections({ employerId, page = 1, itemsPerPage = 30 }: GetDeletedConnectionsArgs) {
    return axios.get(`/admin/employers/${employerId}/deleted-connections`, {
      params: { page, itemsPerPage },
    });
  },

  async restoreConnection({ connectionId }: RestoreConnectionArgs) {
    return axios.put(`/admin/connections/${connectionId}/restore`, {});
  },

  async getConnectionById({ connectionId }: GetConnectionByIdArgs) {
    return axios.get(`/admin/connections/${connectionId}`);
  },

  async uploadNaverrekenenTemplate(file: File) {
    return axios.post(`tools/naverrekenen-template`, {
      parameters: {
        fileName: file.name,
      },
      base64FileContent: await convertFileToBase64(file),
    });
  },
};
